<template>
  <v-card class="ui-module-card loc-personal-shell" color="primary">
    <v-card-text>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <v-row align="center" justify="end" class="mx-0 toolbar-row">
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="filtroLoc"
                  label="Seleccionar LOC"
                  rounded
                  filled
                  dense
                  hide-details
                  color="secondary"
                  background-color="transparent"
                  class="filter-input"
                  :items="locs"
                  item-value="idLoc"
                  item-text="noLicencia"
                  item-color="secondary"
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="filtroPuesto"
                  label="Filtrar por puesto"
                  rounded
                  filled
                  dense
                  hide-details
                  color="secondary"
                  background-color="transparent"
                  class="filter-input"
                  :items="puestos"
                  item-value="catPuesto.puesto"
                  item-text="catPuesto.puesto"
                  item-color="secondary"
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="buscaPersonal"
                  rounded
                  filled
                  dense
                  hide-details
                  background-color="transparent"
                  color="secondary"
                  label="Buscar personal"
                  append-icon="mdi-magnify"
                  class="search-input"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card class="ui-module-card" color="primary" :loading="locSeleccionada && loading">
              <v-card-text>
                <v-data-table
                  :headers="headers"
                  :items="filteredPersonal"
                  class="transparent armory-table"
                  :loading="locSeleccionada && loading"
                  loading-text="Cargando personal..."
                >
                  <template v-slot:no-data>
                    <div class="d-flex flex-column align-center justify-center py-8">
                      <v-icon size="48" color="secondary" class="mb-3">
                        {{ filtroLoc ? 'mdi-account-off-outline' : 'mdi-card-search-outline' }}
                      </v-icon>
                      <span class="text-body-1" style="color: rgba(224,224,224,0.6);">
                        {{ filtroLoc ? 'No se encontró personal vinculado a esta LOC' : 'Seleccione una LOC para ver el personal vinculado' }}
                      </span>
                    </div>
                  </template>
                  <template v-slot:[`item.CUIP`]="{ item }">
                    <span class="text-caption secondary--text font-weight-bold">{{ item.CUIP || '—' }}</span>
                  </template>
                  <template v-slot:[`item.nombreCompleto`]="{ item }">
                    <div class="font-weight-bold">{{ item.nombreCompleto }}</div>
                  </template>
                  <template v-slot:[`item.opciones`]="{ item }">
                    <span class="d-flex align-center action-group">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              variant="secondary"
                              elevation="8"
                              icon="mdi-card-account-details-outline"
                              :to="{
                                path: 'documentos_personal/' + item.id_personal,
                                params: { id: item.id_personal },
                              }"
                            />
                          </span>
                        </template>
                        <span>Ver expediente</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              variant="secondary"
                              elevation="8"
                              icon="mdi-delete-alert-outline"
                              @click="openRemoverLocDialog(item)"
                            />
                          </span>
                        </template>
                        <span>Desvincular LOC</span>
                      </v-tooltip>
                    </span>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import IconButton from '@/components/base/IconButton.vue'
import { DIALOG_TYPES } from '@/plugins/dialog-types'

export default {
  components: { IconButton },
  async mounted() {
    this.loading = true
    await this.fetchLocs()
    await this.fetchPuestosByDependencia(1)
    this.loading = false
  },

  data() {
    return {
      loading: false,
      locSeleccionada: false,
      buscaPersonal: '',
      headers: [
        { text: 'CUIP', value: 'CUIP', sortable: false },
        { text: 'Nombre', value: 'nombreCompleto' },
        { text: 'Puesto', value: 'puesto', sortable: false },
        { text: 'Dependencia', value: 'dependencia', sortable: false },
        { text: 'Subsede', value: 'Subsede', sortable: false },
        { text: 'Opciones', value: 'opciones', sortable: false, align: 'center' },
      ],

      overlay: false,

      filtroPuesto: null,
      filtroLoc: null,
      DIALOG_TYPES,
    }
  },

  watch: {
    async filtroLoc(idLoc) {
      if (!idLoc) return
      this.locSeleccionada = true
      this.loading = true
      await this.fetchPersonalByLoc(idLoc)
      this.loading = false
    },
  },

  computed: {
    ...mapGetters('personalLoc', {
      personal: 'getPersonalByLoc',
    }),

    ...mapGetters('licenciaOficialColectiva', {
      locs: 'getLocs',
    }),

    ...mapGetters('puesto', {
      puestos: 'getPuestos',
    }),

    filteredPersonal() {
      let resultado = this.personal

      if (this.filtroPuesto) {
        resultado = resultado.filter((item) => item.puesto === this.filtroPuesto)
      }

      if (this.buscaPersonal) {
        const busqueda = this.buscaPersonal.toLowerCase()
        resultado = resultado.filter((item) => {
          const nombre = (item.nombreCompleto || '').toLowerCase()
          const cuip = (item.CUIP || '').toLowerCase()
          return nombre.includes(busqueda) || cuip.includes(busqueda)
        })
      }

      return resultado
    },
  },

  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapActions('personalLoc', ['fetchPersonalByLoc', 'fetchPersonalLoc']),
    ...mapActions('armeria', ['removePersonalLoc']),
    ...mapActions('licenciaOficialColectiva', ['fetchLocs']),
    ...mapActions('puesto', ['fetchPuestosByDependencia']),

    openRemoverLocDialog(item) {
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.CONFIRMACION_REMOVER_PERSONAL_LOC,
        props: {
          idPersonal: item.id_personal,
          onConfirm: async () => {
            await this.fetchPersonalLoc(item.id_personal)
            const locsPersonal = this.$store.getters['personalLoc/getPersonalLoc']
            const registro = locsPersonal.find((l) => l.fk_idLoc === this.filtroLoc)
            if (registro) {
              await this.removePersonalLoc({ idPersonal: item.id_personal, idPersonalLoc: registro.idPersonalLoc })
              await this.fetchPersonalByLoc(this.filtroLoc)
            }
            this.$store.dispatch('dialog/closeDialog')
          },
        },
      })
    },
  },
}
</script>

<style scoped>
.loc-personal-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

.ui-module-card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.toolbar-row {
  row-gap: 8px;
}

/* Inputs */
::v-deep .search-input .v-input__slot,
::v-deep .filter-input .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .search-input .v-input__slot:hover,
::v-deep .filter-input .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .search-input .v-input__control,
::v-deep .filter-input .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .search-input input,
::v-deep .filter-input input {
  color: #e0e0e0 !important;
}

::v-deep .search-input .v-label,
::v-deep .filter-input .v-label,
::v-deep .filter-input .v-select__selection,
::v-deep .filter-input .mdi-menu-down,
::v-deep .search-input .mdi-magnify {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .search-input.v-input--is-focused .v-label,
::v-deep .filter-input.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

/* Tabla */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-table-header {
  background: rgba(108, 92, 231, 0.15) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid rgba(108, 92, 231, 0.3) !important;
}

::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(108, 92, 231, 0.1) !important;
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(108, 92, 231, 0.1) !important;
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}

.action-group {
  gap: 4px;
}

::v-deep .action-group .v-btn {
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(108, 92, 231, 0.08) !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px;
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 92, 231, 0.3);
}

::v-deep .v-btn:hover .v-icon {
  color: #6c5ce7 !important;
}

/* Footer */
::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid rgba(108, 92, 231, 0.2) !important;
}

::v-deep .v-data-footer__select .v-select {
  color: #e0e0e0 !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
}

/* Scrollbar */
::-webkit-scrollbar { width: 8px; height: 8px; }
::-webkit-scrollbar-track { background: rgba(10, 10, 10, 0.5); border-radius: 4px; }
::-webkit-scrollbar-thumb { background: rgba(108, 92, 231, 0.4); border-radius: 4px; }
::-webkit-scrollbar-thumb:hover { background: rgba(108, 92, 231, 0.6); }
</style>
